import { render, staticRenderFns } from "./ChooseStoreAdress.vue?vue&type=template&id=87093cc6&scoped=true&"
import script from "./ChooseStoreAdress.vue?vue&type=script&lang=js&"
export * from "./ChooseStoreAdress.vue?vue&type=script&lang=js&"
import style0 from "./ChooseStoreAdress.vue?vue&type=style&index=0&id=87093cc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87093cc6",
  null
  
)

export default component.exports